import React, { useState, useEffect, useRef, Suspense } from "react";
import PageLoader from "../../elements/loader/PageLoader"; //

interface LazyOnViewProps {
  children: React.ReactNode;
  minHeight?: string;
}

const LazyOnView: React.FC<LazyOnViewProps> = ({ children, minHeight = "" }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(window["__isPrerender__"]);

  useEffect(() => {
    if(window["__isPrerender__"]) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ minHeight }}>
      {isVisible ? (
        <Suspense fallback={null}>
          {children}
        </Suspense>
      ) : (
        <></>
      )}
    </div>
  );
};

export default LazyOnView;
